import React, { useState, useCallback, useEffect } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import Input from "components/input/input";
import { isValidYoutubeVideoLink } from "utils/utils";
import LoadingIndicator from "assets/svg/loading-indicator";
import _ from "lodash";
import update from "immutability-helper";
import { useDropzone } from "react-dropzone";
// import { FaPlus, FaMinus } from "react-icons/fa";
import validator from "validator";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import AddPhotoDropZone from "assets/svg/add-photo-dropzone-svg";  
import { KB, MB, maxUploadSize } from "utils/constant";
import { Close } from "assets/svg/sidebar/icons";
import { useTranslation } from "react-i18next";
import EditPencilIconSVG from "assets/svg/edit-pencil-icon";

export default function EditPhotoModal({ hide, userData, profile,data={}, ...props }) {
  const { http } = global.services;
  const [submitLoading, setSubmitLoading] = useState(false);

  const [errorMessages, setErrorMessages] = useState({});
  const [adultContent, setAdultContent] = useState(Boolean(data?.is_adult_content));
  const [photo, setPhoto] = useState(null); 
  const uploadSizeModal = useDialogHook(UploadSizeModal);
  const {t} = useTranslation();
  React.useEffect(() => {
    if (photo) {
      setPhotoPreview();
    }
  }, [photo]);

  const [preview, setPreview] = useState({
    name: data?.media?.file_name,
    size: data?.media?.file_size,
    path: data?.media?.url,
  });


  const [isEditing, setIsEditing] = useState(false);
  const [fileName, setFileName] = useState(data?.media?.file_name);

  const submit = async () => {
    let errors = {};
    setErrorMessages(errors);

    try {
      setSubmitLoading(true); 
      let payload = new FormData();
      let video_id = data?.id;
      payload.append(`user_profile_id`, profile.id);
      payload.append("type", "photo");
      payload.append("file_name", fileName);
      payload.append("is_adult_content", adultContent);
      payload.append("_method", "PUT");

        if (photo && photo[0]) {
            payload.append("thumbnail", photo[0]);
        }

      const response = await http.post(`public/user-galleries/${video_id}`, payload);
      const {data:result} = response;
      console.log(result)
      if (result) {
        hide({data:result.data});
      }
    } catch (err) {
      if (err.status === 422){
        errors = {
          ...errors,
          ...err.data?.errors,
        };
        console.log(errors)
        return setErrorMessages((prev) => ({
          ...prev,
          ...errors
        }));
      }
        
        
      console.log(err);
      setSubmitLoading(false);
    } finally {
      setSubmitLoading(false);
    }
  };

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles[0].size > maxUploadSize) {
      showUploadSizeModalError();
    } else {
      setPhoto(acceptedFiles);
    }
  }, []);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    noClickL: true,
    accept: {
      'image/*': [],
    }
  });

  const showUploadSizeModalError = () => {
    uploadSizeModal({}, (callback) => {
      console.log('callback', callback)
    })
  }


  const removeUploadedPhoto = () => {
    setPhoto(null);
    setPreview({
        name: null,
        size: null,
        path: null,
    });
  }

  useEffect(()=>{
    if(data?.media){
        let size = Number(data?.media?.file_size);
        if (size > MB) {
            size /= MB;
            size = `${Math.round(size * 10) / 10}MB`;
        } else if (size > KB) {
            size /= KB;
            size = `${Math.round(size * 10) / 10}KB`;
        } else {
            size = `${size}B`;
        }
        setPreview((prev)=>{
            return {...prev, size:size}
        })
    }
  },[data])

  const setPhotoPreview = () => {
    console.log(photo[0])
    if (typeof photo === 'string') {
        setPreview({
            name: 'Thumbnail',
            size: 'N/A',
            path: photo
        });
    } else {
        let size = photo[0].size;

        if (size > MB) {
            size /= MB;
            size = `${Math.round(size * 10) / 10}MB`;
        } else if (size > KB) {
            size /= KB;
            size = `${Math.round(size * 10) / 10}KB`;
        } else {
            size = `${size}B`;
        }

        setPreview({
            name: photo[0].name,
            size: size,
            path: URL.createObjectURL(photo[0])
        });
    }
};

  const Footer = () => {
    return (
      <>
        <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2">
          <Button
            buttonName="Cancel"
            buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
            buttonTextClass="text-black text-sm font-semibold"
            onClick={() => hide()}
            disabled={submitLoading}
          />
          <Button
            key="save-btn-category"
            buttonName="Update Photo"
            buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary"
            buttonTextClass="text-white text-sm font-semibold flex items-center"
            onClick={submit}
            disabled={submitLoading}
            loadingIcon={
              submitLoading ? (
                <LoadingIndicator className="text-white w-4 h-4 ml-2" />
              ) : null
            }
          />
        </div>
      </>
    );
  };

  const toggleAdultContentCheckbox = (e) => {
    setAdultContent(!e.target.checked);
  }


  return (
    <Modal
      footer={<Footer />}
      width="w-full md:w-15/20 2md:w-11/20 lg:w-9/20 xl:w-6/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray">
      <div className="w-full">
        {/* header */}
        <ModalHeader title={t('editFile', {file:t('photo')})} hide={hide} />
        {/* content */}
        <div className="px-8.5 pb-6 pt-2">
          {/* profile */}
            <div className="flex flex-column">

          <div className="">
            {/* <div>{thumbnail}</div> */}
            <h1 className="font-bold text-darkerGray">Change photo</h1>
                {/* dropzone */}
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div className="add-photo-dropzone">
                <AddPhotoDropZone />
              </div>
            </div>
              {
                (photo || preview.path) && <div className="flex mt-4 items-center justify-center mt-6">
                  <div className="flex items-center space-x-4 h-[120px] rounded-md shadow-md w-full border-slate-200">
                    <div className="flex items-center space-x-4 text-ellipsis overflow-hidden flex-1">
                      <img
                        src={preview.path}
                        alt="preview-upload"
                        className="relative w-full h-full rounded-md max-h-[120px] max-w-[120px]"
                        style={{ objectFit: 'contain' }}
                      />

                      <div className="flex flex-col w-full">
                        <div className="flex items-center justify-between w-full gap-2">
                          {isEditing ? (
                            <input
                              type="text"
                              value={fileName}
                              onChange={(e) => setFileName(e.target.value)}
                              className="border-none p-0-important w-full"
                            />
                          ) : (
                            <span>{fileName}</span>
                          )}

                          <button
                            type="button"
                            onClick={() => setIsEditing(!isEditing)}
                            className={`${isEditing ? 'text-blue-500' : ''} text-sm`}
                          >
                            {isEditing ? 'Save' : 
                            <div
                              className="cursor-pointer"
                            >
                              <EditPencilIconSVG className="inline mr-1" />
                              {t("rename")}
                            </div>
                            }
                          </button>
                        </div>

                        <span>{preview.size}</span>
                      </div>
                    </div>

                    <div className="cursor-pointer px-2" onClick={removeUploadedPhoto}>
                      <Close className="w-4 h-4" fill={"#333333"} />
                    </div>
                  </div>
                </div>
              }
                <div className="mt-2">
                  <CustomCheckbox
                    label={
                      <p className="checkbox-text">
                        {t('thisFileDoesNotContainAdult', {file:t('photo')})}
                      </p>
                    }
                    name={"termsAndConditions"}
                    checked={!adultContent}
                    onChange={(e) => toggleAdultContentCheckbox(e)}
                    v2={true}
                  />
                </div>
              </div>
            </div>

        </div>
        {/* end content */}
      </div>
    </Modal>
  );
}
